module.exports = __webpack_public_path__ + "img/australia-congenital-and-perinatal-diseases-male.af7c1bac.png";